import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, getUserNameToName, formatData } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import { Breadcrumbs, Button, Input, Label } from '../../../components/UI/ComponentsUI';
import TruckKanbanService from '../../../services/TruckKanbanService';

const Insert = (props) => {
    const update = props.location?.state?.update;
    const [highCostMaterial, setHighCostMaterial] = useState(props.location?.state?.update && props.highCostMaterial ? props.highCostMaterial : {});

    const onChange = (event) => {
        onValueChange(event, highCostMaterial, setHighCostMaterial);
    };

    const onConfirm = () => {
        if (validateInputsRequired("formInsert")) {
            if (update) {
                props.highCostMaterialUpdate(highCostMaterial, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.highCostMaterialInsert(highCostMaterial, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const titleMovementType = { icon: "mdi mdi-clipboard-check-outline", label: translate('high-cost-material', 'truck-kanban') };
    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="highCostMaterialinsert" title={titleMovementType} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formInsert">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumberCode"
                                            name='partNumberCode'
                                            required
                                            placeholder="Material Precioso"
                                            type="text"
                                            defaultValue={highCostMaterial?.partNumberCode || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                {update &&
                                    <div className="row" style={{ marginBottom: '5px' }}>
                                        <Label label={translate('fields.updateBy', 'movement-type')} id="updateBy" value={getUserNameToName(props?.usersFromElog, highCostMaterial?.updatedBy)} />
                                        <Label label={translate('fields.updateOn', 'movement-type')} id="updateOn" value={formatData(highCostMaterial?.updatedOn)} />
                                    </div>
                                }
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        highCostMaterial: state.truckKanbanReducer.highCostMaterial,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        highCostMaterialInsert: (highCostMaterial, callback) => {
            dispatch(TruckKanbanService.addHighCostMaterial(highCostMaterial, callback));
        },
        highCostMaterialUpdate: (highCostMaterial, callback) => {
            dispatch(TruckKanbanService.updateHighCostMaterial(highCostMaterial, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Insert)));
